import { useMutation } from "@tanstack/react-query"
import { DownloadIcon } from "lucide-react"
import { usePostHog } from "posthog-js/react"
import { toast } from "sonner"
import { Button } from "~/components/ui/button"
import { api } from "~/trpc/react"

export function FormCsvExport({
	teamId,
	formId
}: {
	teamId: string
	formId?: string
}) {
	const utils = api.useUtils()
	const posthog = usePostHog()
	const download = useMutation({
		mutationFn: () =>
			utils.forms.exportSubmissions.fetch({ teamId, formId }, { staleTime: 0 }),
		onSuccess: ({ csv, filename, count }) => {
			const url = URL.createObjectURL(
				new Blob([csv], { type: "text/csv;charset=utf-8" })
			)
			const link = document.createElement("a")
			link.href = url
			link.download = filename
			document.body.append(link)
			link.click()
			link.remove()
			window.setTimeout(() => URL.revokeObjectURL(url), 1000)
			posthog.capture("form_submissions_exported", { teamId, formId, count })
		},
		onError: (error) =>
			toast.error(error.message || "Could not export responses")
	})
	return (
		<Button
			variant="outline"
			size="sm"
			icon={<DownloadIcon />}
			pending={download.isPending}
			disabled={!teamId}
			onClick={() => download.mutate()}
		>
			Export CSV
		</Button>
	)
}
